export default {
  title: 'Company Info',

  labels: {
    generalInfo: 'General info',
    telInfo: 'Tell info',
    financialInfo: 'Financial info',
    uploadLogo: 'Upload logo',
    preview: 'Preview:',
    name: 'Company name',
    managerName: 'Manager full name',
    country: 'Country',
    province: 'State',
    city: 'City',
    address: 'Address',
    postCode: 'Post code',
    phoneNumber: 'Phone number',
    whatsAppSupport: 'WhatsApp support',
    managerPhoneNumber: 'Manager phone number'
  },

  description: {
    logoRule: 'Authorized JPG, JPEG or PNG formats. Maximum logo size 800 KB ',
    generalInfo: 'This box displays the general information of the company.',
    telInfo: 'In this box the company contact information is displayed.',
    financialInfo: 'This box displays the companys financial information.'
  },

  validators: {
    imageSize: 'The selected file size is too large',
    fileFormat: 'The selected file format is not allowed',
    name: 'Name is not valid'
  },

  notifications: {
    logo: {
      upload: {
        success: 'Logo uploaded successfully'
      },
      delete: {
        success: 'Logo removed successfully'
      }
    },

    edit: {
      success: 'Store information updated successfully'
    }
  }
}
